import {
  apiClient,
  handleResponse,
} from './axios';

async function uploadCapsule(formData, company, group, userId, examId) {
  try {
    const file = formData.get('uploadedFile');

    const res = await apiClient.post('/examtype5/upload/capsule',
      {
        filename: file.name,
        company,
        group,
        userId,
        examId,
      });
    const response = await handleResponse(res);

    await fetch(response.url, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': 'application/octet-stream',
      },
    });
    return { message: 'file uploaded successfully' };
  } catch (error) {
    return error.response;
  }
}

async function downloadVideoCapsule(fileName) {
  try {
    const response = await apiClient.post('/examtype5/download', { filename: fileName });

    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}
async function deleteVideoCapsule(filename, userId) {
  try {
    const response = await apiClient.post('/examtype5/delete', { filename, userId });

    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function getExamType5(userId, examId) {
  try {
    const response = await apiClient.get(`/examtype5/${userId}/${examId}`);

    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

async function checkVideoCapsule(userId, examId) {
  try {
    const response = await apiClient.post('/examtype5/check', { userId, examId });

    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

const examType5Services = {
  uploadCapsule,
  downloadVideoCapsule,
  deleteVideoCapsule,
  checkVideoCapsule,
  getExamType5,
};

export default examType5Services;
